import React from "react";
import useLogin from "../hooks/useLogin";

// router dom
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../components/elements/form/Button";

// component
import { Divider } from "antd";

// constants
import loginimg from "../../../assets/images/pages/loginpageimg.png";
// import google from "../../../assets/images/icons/logo.png";
import TextInput from "../../../components/elements/form/TextInput";
import { useGoogleLogin } from "@react-oauth/google";
import AnimatedPage from "../../../components/animation/AnimatedPage";
// import { googleLogout, useGoogleLogin } from "@react-oauth/google";

// import { get_google_profile } from "../../../service/api/auth";
import { FaArrowRight, FaGoogle } from "react-icons/fa";
import { useAppSelector } from "../../../store";

const Login: React.FC = () => {
  const navigate = useNavigate();
  // const dispatch = useAppDispatch();
  const loading = useAppSelector(({ auth }) => auth.loading);
  // const { data, g_token, onChange, onSubmit, g_tokenSet } = useLogin();
  const { data, onChange, onSubmit, g_tokenSet } = useLogin();

  const login = useGoogleLogin({
    onSuccess: (res) => g_tokenSet(res?.access_token),
    onError: (error) => console.log("Login Failed:", error),
  });

  // const logOut = () => {
  //   googleLogout();
  // };

  // const onLoad = React.useCallback(() => {
  //   if (g_token) {
  //     get_google_profile(g_token, dispatch, navigate);
  //     g_tokenSet("");
  //   }
  // }, [dispatch, g_token, g_tokenSet, navigate]);

  return (
    <AnimatedPage>
      <main className="min-h-screen w-full bg-customgreen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <section className="max-w-7xl w-full overflow-hidden rounded-2xl shadow-xl bg-white">
          <div className="grid md:grid-cols-2">
            {/* Left Column - Form */}
            <div className="w-full space-y-8 p-8 sm:p-12 lg:p-16">
              <div className="mb-8">
                <h2 className="text-2xl font-bold tracking-tight text-primary-900 sm:text-3xl mb-2">
                  Welcome Back!
                </h2>
                <p className="max-w-2xl mx-auto text-sm text-primary-600">
                  Don’t have an account yet?
                  <Link
                    to="/register"
                    className="ml-2 font-medium text-primary-500 hover:text-primary-900"
                  >
                    Sign up
                  </Link>
                </p>
              </div>
              <form
                className="space-y-6 relative"
                onSubmit={onSubmit}
                action="#"
                method="POST"
              >
                {/* <input type="hidden" name="remember" value="true" /> */}

                <TextInput
                  type="text"
                  label="Email"
                  name="email"
                  value={data.email}
                  placeholder="Email"
                  required={true}
                  onChange={onChange}
                />

                <TextInput
                  type="password"
                  label="Password"
                  name="password"
                  value={data.password}
                  placeholder="Password"
                  required={true}
                  onChange={onChange}
                />

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      className="h-4 w-4 rounded-full border-gray-300"
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-2 block text-sm text-gray-900"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="text-sm">
                    <Link
                      to="/forgot-password"
                      className="font-medium text-bggreen hover:text-primary-600"
                    >
                      Forgot your password?
                    </Link>
                  </div>
                </div>

                <div>
                  <Button
                    title="Sign In"
                    type="submit"
                    loading={loading}
                    onHandler={() => null}
                    className="w-full  text-white px-6 rounded-full"
                    bg_color="bg-primary-900"
                    bg_hoverColor="bg-primary-700"
                  />
                </div>
              </form>
              <Divider>Or</Divider>
              <Button
                type="button"
                title="Sign In with Google"
                titleColor="text-dark"
                icon={<FaGoogle size={24} className="text-dark" />}
                onHandler={() => login()}
                className="w-full rounded-full mb-12 md:mb-0"
                bg_color="bg-primary-50/20 "
                bg_hoverColor="bg-primary-400"
              />
              <Button
                type="button"
                title="Go back to Home"
                titleColor="text-dark hover:text-primary-700"
                rightIcon={
                  <FaArrowRight
                    size={16}
                    className="text-dark group-hover:text-primary-700"
                  />
                }
                onHandler={() => navigate("/")}
                className="px-0 py-0 text-dark hover:text-primary-700"
              />
            </div>
            {/* Right Column - Image & Content */}
            <div className="relative hidden md:block bg-primary-800 m-6 rounded-xl overflow-hidden">
              <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-primary-700/30 blur-3xl"></div>
                <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-primary-600/20 blur-3xl"></div>
              </div>
              <div className="relative h-full flex flex-col justify-center p-12 z-10">
                <div className="mb-8">
                  <h2 className="text-2xl font-bold text-white mb-4 sm:text-3xl">
                    Welcome Back
                  </h2>
                  <p className="text-sm text-white">
                    Sign in to your account to access your dashboard and manage
                    your business services.
                  </p>
                </div>
                <div className="relative h-64 sm:h-80 lg:h-96 w-full">
                  <img
                    src={loginimg}
                    alt="Login illustration"
                    className="object-contain"
                  />
                </div>
                <div className="mt-8">
                  <p className="text-white text-sm">
                    "Corporate Setup has transformed how we manage our business
                    compliance. The platform is intuitive and the support team
                    is exceptional."
                  </p>

                  <p className="mt-4 text-white text-sm font-medium">
                    CEO, Evoke
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </AnimatedPage>
  );
};

export default Login;
